"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailBuildingInfoState = void 0;
var BuildingState_init_1 = require("@/pages/place/states/BuildingState.init");
exports.defaultDetailBuildingInfoState = {
    id: 1043,
    forRentCount: 20,
    forSaleCount: 20,
    medianLeasePrice: BuildingState_init_1.defaultBuildingState.medianLeasePrice,
    medianSalePpsf: BuildingState_init_1.defaultBuildingState.medianSalePpsf,
    galleryItems: BuildingState_init_1.defaultBuildingState.galleryItems,
    features: BuildingState_init_1.defaultBuildingState.features,
    isBlock: 0,
};
